var exports = {
  "Hx": "Flash__myEigm",
  "az": "Box__p32Mwl",
  "m4": "Octicon__mCwvVB",
  "wy": "Box_1__4dfxNF",
  "DZ": "Heading__NAvW8r",
  "pv": "Box_2__L-t9xp",
  "sW": "BannerMarginBottom__xbeKnH",
};

module.exports = exports;
